import { defineComponent as _defineComponent } from 'vue'
import { useCacheStore } from "@/pinia";
import { IToken } from "@/shared";
import { computed, ref, withDefaults } from "vue";

// props
interface IProps {
	mint: string;
	value?: any;
	dataMessage?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterAmount',
  props: {
    mint: null,
    value: null,
    dataMessage: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	mint: string;
	value?: any;
	dataMessage?: string;
};



// computed
const getTokenByMint = computed<IToken | undefined>(() => {
	return cacheStore.tokenList[props.mint];
});
const isInvalid = computed<boolean>(() => {
	return amount.value <= 0;
});

// store
const cacheStore = useCacheStore();

// data
const amount = ref<number>(props.value ?? 0);

// expose
expose({ isInvalid });

return { __sfc: true,props, getTokenByMint, isInvalid, cacheStore, amount }
}

})